import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withUserManager from 'jsx/auth/withUserManager';
import { loadUser } from '../ducks/user';

class Callback extends React.Component {
  componentDidMount() {
    const { location, userManager, history, loadUser } = this.props;
    userManager
      .loginCallback(location.hash)
      .then(path => history.push(path))
      .then(() => loadUser(userManager.getIdTokenPayload()))
      .catch(ex => {
        console.log(ex);
        //userManager.logOut();
      });
  }

  render() {
    return null;
  }
}

Callback.propTypes = {
  userManager: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  loadUser: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
};

const mapDispatch = dispatch => ({ loadUser: bindActionCreators(loadUser, dispatch) });

export default connect(null, mapDispatch)(withUserManager(Callback));



// WEBPACK FOOTER //
// ./src/common/jsx/auth/Callback.js